import Box from '@material-ui/core/Box';
import Pagination from '@material-ui/lab/Pagination';
import PropTypes from 'prop-types';
import React from 'react';
import TablePaginationItem from './utils/TablePaginationItem';

const TablePagination = ({ numberOfPages, currentPage, goToPageEvent }) => {
  return (
    <Box display="flex" justifyContent="center">
      <Pagination
        count={numberOfPages}
        shape="rounded"
        hideNextButton
        hidePrevButton
        page={currentPage}
        renderItem={item => (
          <TablePaginationItem {...item} goToPageEvent={goToPageEvent} />
        )}
      />
    </Box>
  );
};

TablePagination.propTypes = {
  numberOfPages: PropTypes.number,
  currentPage: PropTypes.number,
  goToPageEvent: PropTypes.string,
};

TablePagination.defaultProps = {
  numberOfPages: 1,
  currentPage: 1,
  goToPageEvent: undefined,
};

export default TablePagination;
